import { ThemeOverride } from "@chakra-ui/react";

export const fonts: ThemeOverride["fonts"] = {
  heading: '"Mulish", sans-serif',
  body: '"Mulish", sans-serif',
  mono: '"Roboto Mono", monospace',
};
